class CareerOppsController {
  constructor(JPMCService) {
    // Directive Data
    this.jobFamily = JPMCService.getJobFamilyById(this.jobFamilyId);
  }
}

CareerOppsController.$inject = ['JPMCService'];

export default CareerOppsController;



// WEBPACK FOOTER //
// ./src/components/careerOpps/careerOpps.controller.js